/* ==========================================================================
   Oh!My Snacks — setas da galeria da ficha de produto
   ==========================================================================
   Acrescenta uma seta de cada lado da imagem grande, para andar de imagem sem
   ter de acertar numa miniatura.

   Não reimplementa a galeria: chama o `setActiveMedia` do próprio
   `<media-gallery>` do tema, que é quem já sabe trocar a imagem, marcar a
   miniatura com `aria-current`, anunciar na live region e pausar vídeo. Aqui só
   se decide QUAL a imagem seguinte e quando é que cada seta existe.

   Porque é por JS e não por Liquid: a galeria é desenhada pelo
   `snippets/product-media-gallery.liquid`, que é partilhado por todos os
   templates de produto. Injectar daqui evita tocar num ficheiro de que outros
   templates dependem. A troca de imagem já era de JS (é o `media-gallery.js`
   que liga as miniaturas), portanto não se perde nada que existisse sem ele.

   Os botões nativos do tema (`.slider-buttons`) ficam onde estão, escondidos
   com `display:none` pelo próprio tema. Aproveitam-se só os rótulos. Não se
   podem apagar: sem o botão `next` o <slider-component> nem ouve o scroll, e o
   arrasto deixava de acertar as miniaturas.

   Desde 2026-09-24 a galeria anda também com o dedo, porque a pele a pôs em
   fita com scroll-snap. O arrasto não passa por aqui: é scroll nativo, e o
   tema avisa com o `slideChanged`. Ver `sincronizar`, mais abaixo.
   ========================================================================== */
(function () {
  'use strict';

  var ANTERIOR = -1;
  var SEGUINTE = 1;

  function desenho(direccao) {
    // Grelha de 24, traço de 1,5, terminações redondas: a regra de ícone da marca.
    var d = direccao === ANTERIOR ? 'M14.5 6.5 9 12l5.5 5.5' : 'M9.5 6.5 15 12l-5.5 5.5';
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>';
  }

  function iniciar(galeria) {
    var visor = galeria.querySelector('[id^="GalleryViewer"]');
    if (!visor || typeof galeria.setActiveMedia !== 'function') return;

    var itens = Array.prototype.slice.call(
      visor.querySelectorAll('.product__media-item[data-media-id]')
    );
    // Com uma imagem só não há para onde andar, e duas setas mortas por cima de
    // uma fotografia são pior do que nenhuma.
    if (itens.length < 2) return;
    if (visor.querySelector('.oms-pdp-seta')) return;

    function indiceActivo() {
      for (var i = 0; i < itens.length; i++) {
        if (itens[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    /* O rótulo sai da miniatura de destino, que o tema já desenha com
       `products.product.media.load_image` traduzido e com o número da imagem lá
       dentro ("Carregar imagem 2 na vista de galeria"). Assim não se acrescenta
       chave de idioma nenhuma e o texto acompanha o mercado. Se por alguma razão
       não houver miniatura, recua-se para o rótulo do botão nativo do slider. */
    function rotulo(indice, direccao) {
      var alvo = itens[indice];
      if (alvo) {
        var mini = galeria.querySelector('[data-target="' + alvo.dataset.mediaId + '"] button');
        if (mini && mini.getAttribute('aria-label')) return mini.getAttribute('aria-label');
      }
      var nativo = galeria.querySelector(
        '.slider-button--' + (direccao === ANTERIOR ? 'prev' : 'next')
      );
      return (nativo && nativo.getAttribute('aria-label')) || '';
    }

    function faz(direccao) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'oms-pdp-seta oms-pdp-seta--' + (direccao === ANTERIOR ? 'ant' : 'seg');
      b.innerHTML = desenho(direccao);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        andar(direccao);
      });
      return b;
    }

    function andar(direccao) {
      var i = indiceActivo() + direccao;
      if (i < 0 || i >= itens.length) return;
      galeria.setActiveMedia(itens[i].dataset.mediaId, false);
      // O setActiveMedia é síncrono na parte que interessa (troca a classe), mas
      // deixa trabalho num setTimeout. Actualizar já evita um piscar das setas.
      actualizar();
    }

    var ant = faz(ANTERIOR);
    var seg = faz(SEGUINTE);

    function actualizar() {
      var i = indiceActivo();
      // Na primeira imagem não há seta à esquerda, e na última não há à direita.
      ant.hidden = i <= 0;
      seg.hidden = i >= itens.length - 1;
      ant.setAttribute('aria-label', rotulo(i - 1, ANTERIOR));
      seg.setAttribute('aria-label', rotulo(i + 1, SEGUINTE));
    }

    visor.appendChild(ant);
    visor.appendChild(seg);
    actualizar();

    /* As miniaturas continuam a funcionar e mudam a imagem sem passar por aqui.
       Observar a classe `is-active` mantém as setas certas venha a troca de onde
       vier, incluindo de uma re-renderização por variante. */
    var observador = new MutationObserver(actualizar);
    itens.forEach(function (li) {
      observador.observe(li, { attributes: true, attributeFilter: ['class'] });
    });

    /* O arrasto com o dedo ou com o trackpad muda a imagem por scroll, e o tema
       só avisa com o `slideChanged` do <slider-component>. O `media-gallery.js`
       acerta a miniatura com esse evento, mas não mexe no `is-active`, que é de
       onde as setas leem a posição. Sem isto, depois de arrastar para a segunda
       imagem, a seta seguinte achava que ainda estava na primeira e andava para
       onde já se estava. Acertar o `is-active` põe o observador de cima a
       actualizar as setas. */
    function sincronizar(e) {
      var atual = e.detail && e.detail.currentElement;
      if (!atual || atual.classList.contains('is-active')) return;
      itens.forEach(function (li) {
        li.classList.toggle('is-active', li === atual);
      });
    }

    visor.addEventListener('slideChanged', sincronizar);

    // Setas do teclado, com o foco dentro da galeria.
    visor.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { andar(ANTERIOR); }
      else if (e.key === 'ArrowRight') { andar(SEGUINTE); }
      else { return; }
      e.preventDefault();
    });
  }

  /* O <media-gallery> tem de estar DEFINIDO, não só presente: sem o custom element
     actualizado não há `setActiveMedia` e o `iniciar` sai pela porta do lado sem
     desenhar seta nenhuma.

     E isso acontece mesmo: este ficheiro é carregado pela secção `oms-pdp-skin`, que
     é a primeira do template, enquanto o `media-gallery.js` vem com a secção `main`,
     mais abaixo. Os scripts `defer` executam por ordem no documento, portanto este
     corre PRIMEIRO. Medido a 2026-09-15: com o `iniciar` só no DOMContentLoaded, o
     ficheiro respondia 200, a galeria existia, e mesmo assim não aparecia uma seta.

     A chamada directa cobre o caso de já estar definido; a promessa cobre o resto. */
  function arrancar() {
    document.querySelectorAll('media-gallery').forEach(iniciar);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('media-gallery').then(function () {
        document.querySelectorAll('media-gallery').forEach(iniciar);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  /* O `product-info.js` substitui a galeria quando muda a variante. Hoje não
     acontece — os 116 produtos do catálogo têm variante única — mas se um dia
     acontecer, as setas injectadas iam embora com o DOM velho.

     O observador fica preso ao <product-info> e não ao <body>: no body dispararia
     a cada mudança de DOM de qualquer app da página, e há várias a mexer-lhe. */
  document.addEventListener('shopify:section:load', arrancar);
  document.querySelectorAll('product-info').forEach(function (raiz) {
    new MutationObserver(function () {
      raiz.querySelectorAll('media-gallery').forEach(function (g) {
        var visor = g.querySelector('[id^="GalleryViewer"]');
        if (visor && !visor.querySelector('.oms-pdp-seta')) iniciar(g);
      });
    }).observe(raiz, { childList: true, subtree: true });
  });
})();
